var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 1.15625C0.25 0.800781 0.523438 0.5 0.90625 0.5H11.8438C12.1992 0.5 12.5 0.800781 12.5 1.15625C12.5 1.53906 12.1992 1.8125 11.8438 1.8125H0.90625C0.523438 1.8125 0.25 1.53906 0.25 1.15625ZM0.25 5.53125C0.25 5.17578 0.523438 4.875 0.90625 4.875H11.8438C12.1992 4.875 12.5 5.17578 12.5 5.53125C12.5 5.91406 12.1992 6.1875 11.8438 6.1875H0.90625C0.523438 6.1875 0.25 5.91406 0.25 5.53125ZM11.8438 10.5625H0.90625C0.523438 10.5625 0.25 10.2891 0.25 9.90625C0.25 9.55078 0.523438 9.25 0.90625 9.25H11.8438C12.1992 9.25 12.5 9.55078 12.5 9.90625C12.5 10.2891 12.1992 10.5625 11.8438 10.5625Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.50ba2aa895200edb85a88cf4d0930a34.svg";
export { ForwardRef as ReactComponent };